export const TEXTS = {
    DEFAULT_LABEL: "Link Account",
    PROCEED: "Proceed",
    CONFIRM_AND_PROCEED: "Confirm and Proceed",
    LINK_DIALOG_SECONDARYRY_ACTION_TEXT: "Cancel",
    X_WALLET_LINKED_TO: "{0} account linked to ",
    LAZYPAY_LINKED_TEXT: "{0} Account has been linked successfully!",
    SUCCESSFULLY: "successfully!",
    PHONENO_INPUT_LABEL: "Phone number",
    PHONENO_INPUT_ERROR_MESSAGE: "Incorrect phone number",
    ALL_METHODS_USABLE: "You can now use all active {0} methods on Swiggy",
};
